/* FAQ accordion, ported from BoxerBriefFAQSection.tsx: single-open,
   first item open on load, clicking the open item closes it. */

class S1Faq extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-s1-faq-toggle]');
      if (!toggle) return;
      const item = toggle.closest('[data-s1-faq-item]');
      const wasOpen = item.classList.contains('is-open');
      this.querySelectorAll('[data-s1-faq-item].is-open').forEach((i) => {
        i.classList.remove('is-open');
        i.querySelector('[data-s1-faq-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }
}

if (!customElements.get('s1-faq')) customElements.define('s1-faq', S1Faq);
